import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { Dialog, DialogContent, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router';

const NOMINEE_POPUP_SHOWN_KEY = 'nomineePopupShownDate';

export const NomineePopup = ({ folio, isDashboard = false }: { folio?: string | null; isDashboard?: boolean }) => {
    const [open, setOpen] = useState(false);
    const history = useHistory();
    const { noNomineeFolios, pan }: { noNomineeFolios: string[]; pan: string } = useSelector(
        ({ portfolio, authReducer }: RootStateType) => ({
            noNomineeFolios: portfolio?.noNomineeFolios || [],
            pan: authReducer?.pan || '',
        }),
    );
    
    useEffect(() => {
        try {
            // For dashboard, only show once per day per user
            if (isDashboard) {
                if (!pan || !noNomineeFolios || !Array.isArray(noNomineeFolios) || noNomineeFolios.length === 0) {
                    return;
                }
                
                const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
                const storageKey = `${NOMINEE_POPUP_SHOWN_KEY}_${pan}`;
                const lastShownDate = localStorage.getItem(storageKey);
                
                // Show popup only if not shown today
                if (lastShownDate !== today) {
                    setOpen(true);
                    localStorage.setItem(storageKey, today);
                }
            } else if (folio) {
                // For transaction screens with folio, show if that specific folio has no nominee
                if (noNomineeFolios && Array.isArray(noNomineeFolios) && noNomineeFolios.includes(folio.toString())) {
                    setOpen(true);
                }
            } else {
                // For transaction screens without folio (like SWP), show if any folio has no nominee
                if (noNomineeFolios && Array.isArray(noNomineeFolios) && noNomineeFolios.length > 0) {
                    setOpen(true);
                }
            }
        } catch (error) {
            // Silently fail - don't break the app if localStorage is unavailable
        }
    }, [folio, noNomineeFolios, pan, isDashboard]);
    return (
        <Dialog
            maxWidth="sm"
            fullWidth
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="nomination-reminder-modal"
            className="opt-out-modal-dialog"
        >
            <div className="opt-out-modal-header">
                <span className="opt-out-modal-title">Nomination Reminder</span>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    className="close-btn"
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <DialogContent className="opt-out-modal-content">
                <div className="opt-out-modal-body">
                    <p className="intro-text">
                        It is noted that you have opted-out of nomination earlier, or nominee
                        details are not found in your folio.
                    </p>
                    <p className="understand-text">Please note that –</p>
                    <ul className="implications-list">
                        <li>
                            Nomination helps to quickly identify the person for transfer of
                            securities and helps in faster and smoother transmission of your
                            securities to your legal heir(s) after your demise.
                        </li>
                        <li>
                            In the absence of a nomination, your legal heir(s) may require the
                            submission of certain additional legal or court-issued documents
                            which may delay the process of transmission of securities.
                        </li>
                        <li>
                            If no claim is made on the account / folio for a prolonged period
                            after your demise, the holdings may be treated as unclaimed assets
                            and may be transferred to Investor Education and Protection Fund
                            Authority (IEPF) in accordance with the applicable regulatory
                            framework.
                        </li>
                    </ul>
                    <p className="intro-text">
                        If you wish to nominate now, please{' '}
                        <a
                            href="#"
                            style={{ color: '#836fe0', textDecoration: 'underline' }}
                            onClick={(e) => {
                                e.preventDefault();
                                setOpen(false);
                                history.replace('/portal/nct/update-nominee');
                            }}
                        >
                            click here
                        </a>
                        .
                    </p>
                    <div className="modal-buttons">
                        <Button
                            variant="contained"
                            className="confirm-btn enabled"
                            onClick={() => setOpen(false)}
                        >
                            Continue
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
